import React, { forwardRef } from "react";
import cx from "classnames";
import styles from "./PrintReportVisitPdf.module.css";
import { useLocalization } from "../../../context/LocalizeContextProvider";

const PrintReportVisitPdf = forwardRef(({ data, filterLabel = "" }, ref) => {
  const localize = useLocalization();

  const totalPatients = (data || []).reduce(
    (total, item) => total + (item.totalPatients || 0),
    0
  );
  const totalMalePatients = (data || []).reduce(
    (total, item) => total + (item.totalMalePatients || 0),
    0
  );
  const totalFemalePatients = (data || []).reduce(
    (total, item) => total + (item.totalFemalePatients || 0),
    0
  );

  return (
    <div ref={ref} className={cx(styles.tableContainer)}>
      <div className={styles.reportHeader}>
        <h2 className={styles.reportTitle}>Laporan Kunjungan</h2>
        {filterLabel ? (
          <p className={styles.reportSubtitle}>{filterLabel}</p>
        ) : null}
        <p className={styles.reportMeta}>
          Dicetak: {new Date().toLocaleString("id-ID")}
        </p>
      </div>

      <table className={styles.visitTable}>
        <thead>
          <tr>
            <th>{localize.getText("doctor")}</th>
            <th>{localize.getText("totalPatient")}</th>
            <th>{localize.getText("totalPasientMan")}</th>
            <th>{localize.getText("totalPasientWoman")}</th>
          </tr>
        </thead>
        <tbody>
          {(data || []).map((item, index) => (
            <tr key={index}>
              <td>{item?.doctorName || "-"}</td>
              <td>{item.totalPatients || 0}</td>
              <td>{item.totalMalePatients || 0}</td>
              <td>{item.totalFemalePatients || 0}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td className={styles.footerTotalLabel}>Total</td>
            <td className={styles.footerTotalValue}>{totalPatients}</td>
            <td className={styles.footerTotalValue}>{totalMalePatients}</td>
            <td className={styles.footerTotalValue}>{totalFemalePatients}</td>
          </tr>
        </tfoot>
      </table>

      <div className={styles.wrapperTotal}>
        <p>Total Pasien</p>
        <p className={styles.totalValue}>{totalPatients}</p>
      </div>
      <div className={styles.wrapperTotal}>
        <p>Total Pasien Laki-laki</p>
        <p className={styles.totalValue}>{totalMalePatients}</p>
      </div>
      <div className={styles.wrapperTotal}>
        <p>Total Pasien Perempuan</p>
        <p className={styles.totalValue}>{totalFemalePatients}</p>
      </div>
    </div>
  );
});

export default PrintReportVisitPdf;
